import { useMemo } from 'react'

import { Role } from 'src/constants/roles'
import useAuth from 'src/hooks/useAuth'

const useRole = () => {
  const { user } = useAuth()

  const role = (user?.role as Role) || null

  return useMemo(
    () => ({
      role,
      isAdmin: role === Role.ADMIN,
      isManager: role === Role.MANAGER,
      isUser: role === Role.USER,
      hasRole: (requiredRoles: Role[]) =>
        role !== null && requiredRoles.includes(role),
      canWrite: role === Role.ADMIN || role === Role.MANAGER
    }),
    [role]
  )
}

export default useRole
